import React from 'react';
import CalculusOfMeaning from '../components/CalculusOfMeaning';

function CalculusPage() {
  return <CalculusOfMeaning />;
}

export default CalculusPage;
